import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 10,
            static: true,
            w: 12,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 10,
            static: true,
            w: 12,
            x: 12,
            y: 2,
            i: 'c3',
        },
        {
            h: 7,
            static: true,
            w: 24,
            x: 0,
            y: 12,
            i: 'c4',
        },
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 10,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 10,
            static: true,
            w: 24,
            x: 0,
            y: 12,
            i: 'c3',
        },
        {
            h: 7,
            static: true,
            w: 24,
            x: 0,
            y: 22,
            i: 'c4',
        },
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    xs: [
        {
            h: 10,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c2',
        },
        {
            h: 10,
            static: true,
            w: 24,
            x: 0,
            y: 13,
            i: 'c3',
        },
        {
            h: 7,
            static: true,
            w: 24,
            x: 0,
            y: 23,
            i: 'c4',
        },
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        period: '1M',
        analysis_type: 'total_pnl',
        analysis_types: [
            {
                label: 'ui.mm.total-pnl',
                value: 'total_pnl',
                path: 'review-all/movers',
                ga_event_name: 'Movers > Total PNL',
            },
            {
                label: 'price',
                value: 'price',
                ga_event_name: 'Movers > Price',
            },
        ],
    },
    components: [
        {
            name: 'page-header',
            key: 'c1',
            props: {
                header: {
                    title: 'ui.mm.page-header-movers',
                },
                rhsComponents: [
                    {
                        name: 'date-range-picker',
                        props: {
                            defaultPeriod: '3M',
                            visiblePeriods: [
                                '1m',
                                '3m',
                                '6m',
                                '1y',
                                'mtd',
                                'qtd',
                                'ytd',
                                'all',
                            ],
                        },
                    },
                    {
                        name: 'multi-level-filters',
                        props: {
                            filterApi: 'filters/movers',
                        },
                    },
                ],
            },
        },
        {
            name: 'movers-container',
            key: 'c2',
            props: {
                type: 'moversTop',
                mode: 'Price',
                numberOfTilesPerRow: 5,
                numberOfTiles: 5,
                dataKey: 'top',
            },
            apiDetails: {
                endpoint: `charts/movers?`,
                endpointParams: {
                    to_date: '*,to_date',
                    from_date: '*,from_date',
                    parent_user_ids: 'parent_user_id',
                    top_n: '*,top_n',
                    type: 'type',
                    analysis_type: '*,analysis_type',
                    ccy_account_ids: 'ccy_account_id',
                    child_user_ids: 'child_user_id',
                    contract_currency: 'contract_currency',
                    custodian_name: 'custodian_name',
                    user_asset_class: 'user_asset_class',
                    user_geography: 'user_geography',
                    user_industry: 'user_industry',
                },
            },
        },
        {
            name: 'movers-container',
            key: 'c3',
            props: {
                type: 'moversBottom',
                numberOfTilesPerRow: 7,
                numberOfTiles: 5,
                dataKey: 'bottom',
            },
            apiDetails: {
                endpoint: `charts/movers?`,
                endpointParams: {
                    to_date: '*,to_date',
                    from_date: '*,from_date',
                    parent_user_ids: 'parent_user_id',
                    top_n: '*,top_n',
                    type: 'type',
                    analysis_type: '*,analysis_type',
                    ccy_account_ids: 'ccy_account_id',
                    child_user_ids: 'child_user_id',
                    contract_currency: 'contract_currency',
                    custodian_name: 'custodian_name',
                    user_asset_class: 'user_asset_class',
                    user_geography: 'user_geography',
                    user_industry: 'user_industry',
                },
            },
        },
        {
            name: 'canopy-table',
            key: 'c4',
            apiDetails: {
                endpoint: `portfolio/movers?`,
                endpointParams: {
                    to_date: '*,to_date',
                    from_date: '*,from_date',
                    parent_user_ids: 'parent_user_id',
                    per_page: '*,per_page',
                    analysis_type: '*,analysis_type',
                    page: '*,page',
                    ccy_account_ids: 'ccy_account_id',
                    child_user_ids: 'child_display_name',
                    contract_currency: 'contract_currency',
                    custodian_name: 'custodian_name',
                    user_asset_class: 'user_asset_class',
                    user_geography: 'user_geography',
                    user_industry: 'user_industry',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                    keyword: 'keyword',
                    // parent_user_ids:'parent_user_id'
                },
            },
            props: {
                dataKey: 'movers',
                title: '',
                showFilterOn: [],
                showDownloadOn: ['desktop'],
                serverSideSearch: true,
                columns: [
                    {
                        key: 'security_name',
                        otherKeys: ['ticker'],
                        type: 'splitCell',
                        headerText: 'ui.mm.table-headers.security-name',
                        selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                        width: 200,
                        canSort: true,
                    },
                    {
                        key: 'start_date',
                        type: 'date',
                        headerText: 'ui.mm.table-headers.start-date',
                    },
                    {
                        key: 'end_date',
                        type: 'date',
                        headerText: 'ui.mm.table-headers.end-date',
                    },
                    {
                        key: 'parent_display_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-display-name',
                        canSort: true,
                    },
                    {
                        key: 'parent_username',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-username',
                        canSort: false,
                    },
                    {
                        key: 'child_display_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-display-name',
                        canSort: true,
                    },
                    {
                        key: 'child_username',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-username',
                        canSort: true,
                    },
                    {
                        key: 'ccy_account_code',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.ccy-account-code',
                        canSort: true,
                    },
                    {
                        key: 'user_asset_class',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.asset-class',
                        canSort: true,
                    },
                    {
                        key: 'user_industry',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.sub-asset-class',
                        canSort: true,
                    },
                    {
                        key: 'user_geography',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.geography',
                        canSort: true,
                    },
                    {
                        key: 'custodian_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.custodian-name',
                        canSort: true,
                    },
                    {
                        key: 'contract_currency',
                        type: 'text',
                        headerText: 'table-headers.ccy',
                        canSort: true,
                    },
                    {
                        key: 'base_currency',
                        type: 'text',
                        headerText: 'table-headers.base-ccy',
                        selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                    },
                    {
                        key: 'start_quantity',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.start-quantity',
                    },
                    {
                        key: 'end_quantity',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.end-quantity',
                    },
                    {
                        key: 'avg_price',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.average-puchase-price',
                    },
                    {
                        key: 'start_market_price',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.start-market-price',
                    },
                    {
                        key: 'end_market_price',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.end-market-price',
                    },
                    {
                        key: 'price_change',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.price-change',
                    },
                    {
                        key: 'price_change_percent',
                        type: 'percent',
                        headerText: 'ui.mm.table-headers.price-change-percent',
                    },
                    {
                        key: 'market_value_ccy',
                        type: 'amount',
                        headerText: 'table-headers.value',
                    },
                    {
                        key: 'market_value_base_ccy',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.market_value_base_ccy',
                        canSort: true,
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_currency',
                            },
                        ],
                    },

                    {
                        key: 'profit_realized_trading_ccy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.realized-trading-profit',
                    },
                    {
                        key: 'profit_realized_trading_base_ccy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.realized-trading-profit-base-ccy',
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_currency',
                            },
                        ],
                        selectedByDefaultOn: ['desktop'],
                    },
                    {
                        key: 'profit_distributions_ccy',
                        type: 'amount',
                        width: 150,
                        headerText: 'ui.mm.table-headers.total-distribution',
                    },
                    {
                        key: 'profit_distributions_base_ccy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.total-distribution-base-ccy',
                        width: 150,
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_currency',
                            },
                        ],
                        selectedByDefaultOn: ['desktop'],
                    },
                    {
                        key: 'profit_contributions_ccy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.profit_contributions_ccy',
                        canSort: true,
                        width: 130,
                    },
                    {
                        key: 'profit_contributions_base_ccy',
                        type: 'amount',
                        width: 130,
                        headerText:
                            'ui.mm.table-headers.profit-contributions_base_ccy',
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_currency',
                            },
                        ],
                        canSort: true,
                    },
                    {
                        key: 'profit_unrealized_ccy',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.unrealized-profit',
                    },

                    {
                        key: 'profit_unrealized_base_ccy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.unrealized-profit-base-ccy',
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_currency',
                            },
                        ],
                        selectedByDefaultOn: ['desktop'],
                    },
                    {
                        key: 'profit_total_ccy',
                        type: 'amount',
                        headerText: 'table-headers.total-profit',
                    },
                    {
                        key: 'profit_total_base_ccy',
                        type: 'amount',
                        colSpan: '1',
                        width: 120,
                        canSort: true,
                        headerText:
                            'ui.mm.table-headers.total-profit-base-value',
                        selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                        headerTextVariables: [
                            {
                                key: 'ccy',
                                value: 'base_currency',
                            },
                        ],
                    },
                ],
                per_page: 25,
                ga_event_name: 'Review All Movers ',
            },
        },
    ],
};
